import { departmentsConstants } from './constants';

export const initialState = {
  data: [],
  pending: false,
};

export function departments(state = initialState, action) {
  switch (action.type) {
    case departmentsConstants.GET_DEPARTMENTS_REQUEST:
      return {
        ...initialState,
        pending: true,
      };
    case departmentsConstants.GET_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        data: action.departments,
        pending: false,
      };
    case departmentsConstants.GET_DEPARTMENTS_FAILURE:
    default:
      return state;
  }
}
